export default __webpack_public_path__ + "static/media/Gale Kick.3c5ded58.png";